import { useState, useEffect } from 'react';
import { useCart } from '../Context/CartContext';
import { useAuth } from '../Context/AuthContext';
import { useLocation } from 'react-router-dom';
import '../Components/Styles/checkout.css'

function formatPhoneNumberWithDash(number) {
  if (!number) return '';
  let cleaned = number.replace(/\D/g, '');
  if (cleaned.startsWith('0')) {
    cleaned = cleaned.slice(1);
  }
  return '+33-' + cleaned;
}

function Checkout() {
  const { cartItems, total } = useCart();
  const { user } = useAuth(); 
  console.log('user:', user);

  const [serverTotals, setServerTotals] = useState(null);

  const [deliveryMode, setDeliveryMode] = useState('domicile');
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');

  const [billingAddress, setBillingAddress] = useState('');
  const [billingPostalCode, setBillingPostalCode] = useState('');
  const [billingCity, setBillingCity] = useState('');
  const [billingCountry, setBillingCountry] = useState('');

  const [shippingAddress, setShippingAddress] = useState('');
  const [shippingPostalCode, setShippingPostalCode] = useState('');
  const [shippingCity, setShippingCity] = useState('');
  const [shippingCountry, setShippingCountry] = useState('');

  const [companyName, setCompanyName] = useState('');
  const [vatNumber, setVatNumber] = useState('');
  const [siret, setSiret] = useState('');
  
  const [orderSummary, setOrderSummary] = useState(null);

  const location = useLocation();
  const { promoCode, remise } = location.state || {};

  const CLICK_COLLECT_LOCATIONS = [
  {
    id: "campigneulles",
    nom: "FamilyFitness",
    adresse: "Zone d'activité",
    postalCode: "62170",
    ville: "Campigneulles-les-Petites",
    pays: "FR",
  },
  {
    id: "attin",
    nom: "Fit Style",
    adresse: "8 route d'Etaples",
    postalCode: "62170",
    ville: "Attin",
    pays: "FR",
  },
];

  const calculateDeliveryCost = () => {
    if (deliveryMode === 'relais') {
      return 0;
    }
    if (total < 40) return 2.99;
    return 0;
  };

   useEffect(() => {
    fetch('/api/adresses.php', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setSavedAddresses(data.adresses);
      });
  }, []);

 const handleSelectAddress = (id) => {
  setSelectedAddress(id);
  const addr = savedAddresses.find(a => a.id === parseInt(id));
  if (addr) {
    setShippingAddress(addr.shippingAddress.addressLine1);
    setShippingPostalCode(addr.shippingAddress.postalCode);
    setShippingCity(addr.shippingAddress.city);
    setShippingCountry(addr.shippingAddress.country);
  }
};

  const isContactComplete = firstName && lastName && phone;
  const isBillingComplete = billingAddress && billingPostalCode && billingCity && billingCountry;
  const isShippingComplete =
  deliveryMode === 'domicile'
    ? shippingAddress && shippingPostalCode && shippingCity && shippingCountry
    : selectedAddress;
    
useEffect(() => {
  if (!cartItems.length) return;

  const fetchTotals = async () => {
    const deliveryCost = calculateDeliveryCost();
    const payload = {
      ids: cartItems.map(item => ({
        product_id: item.product_id,
        variante_id: item.variante_id,
        variante_option_id: item.variante_option_id,
        quantity: item.quantity,
      })),
      deliveryMode,
      deliveryCost,
      promoCode: promoCode || null,
    };

    try {
      const res = await fetch('/api/calculate_order.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.success) {
        setServerTotals(data);
      }
    } catch (err) {
      console.error("Erreur calcul commande :", err);
    }
  };

  fetchTotals();
}, [cartItems, deliveryMode, total, promoCode]);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!firstName || !lastName || !phone) {
      alert("Veuillez remplir vos informations personnelles.");
      return;
    }

  if (!billingAddress || !billingPostalCode || !billingCity || !billingCountry) {
    alert("Veuillez remplir l'adresse de facturation complète.");
    return;
  }

  if (deliveryMode === 'domicile') {
    if (!shippingAddress || !shippingPostalCode || !shippingCity || !shippingCountry) {
      alert("Veuillez remplir l'adresse de livraison complète.");
      return;
    }
  }

  if (deliveryMode === 'relais') {
    if (!selectedAddress) {
      alert("Veuillez sélectionner un point de retrait.");
      return;
    }
  }

    const produitsAverifier = cartItems.map(item => ({
    variante_option_id: item.variante_option_id,
    quantite: item.quantity
  }));
  console.log("Produits à vérifier pour le stock :", produitsAverifier);

  try {
  const response = await fetch('/api/check_stock.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ produits: produitsAverifier }),
  });

  const raw = await response.text();
  console.log("Réponse brute du serveur:", raw);

  let data;
  try {
    data = JSON.parse(raw);
  } catch (err) {
    console.error("Erreur parse JSON:", err);
    alert("Réponse du serveur invalide.");
    return;
  }

  if (!data.ok) {
    alert(data.message || "Stock insuffisant pour un ou plusieurs produits.");
    return; 
  }

} catch (error) {
  console.error("Erreur réseau/fetch:", error);
  alert("Erreur lors de la vérification du stock. Veuillez réessayer.");
  return;
}
const selectedLocation = CLICK_COLLECT_LOCATIONS.find(
  (loc) => loc.id === selectedAddress
);
if (deliveryMode === 'relais' && !selectedLocation) {
  alert("Veuillez sélectionner un point de retrait valide.");
  return;
}

  const selectedSavedAddress = savedAddresses.find(a => a.id === selectedAddress);
  const deliveryCost = calculateDeliveryCost();
  const montantFinal = orderSummary?.totalFinal ?? 0;
  const payload = {
    ids: cartItems.map(item => {
      if (item.type === "pack") {
        return {
          type: "pack",
          pack_id: item.pack_id,
          nom: item.nom,
          price: item.price,
          quantity: item.quantity,
          items: item.items.map(p => ({
            product_id: p.product_id,
            variante_id: p.variante_id,
            variante_option_id: p.variante_option_id,
            quantity: p.quantity
          }))
        };
      }
      return {
        type: "product",
        product_id: item.product_id,
        variante_id: item.variante_id,
        variante_option_id: item.variante_option_id,
        quantity: item.quantity
      };
    }),
  deliveryMode,
  promoCode: promoCode || null,
  pointRelais:
  deliveryMode === 'relais'
    ? selectedLocation
    : null,
  client: {
    email: user?.email,
    phone: formatPhoneNumberWithDash(phone),
    firstName,
    lastName,
    birthCity: "",
    birthPostalCode: "",
    birthCountry: "",
    birthdate: "",
    companyName,   // facultatif
    vatNumber,     // facultatif
    siret 
  },
  billingAddress: {
    addressLine1: billingAddress,
    postalCode: billingPostalCode,
    city: billingCity,
    country: billingCountry.toUpperCase(),
  },
  shippingAddress: selectedSavedAddress
  ? {
      ...selectedSavedAddress.shippingAddress,
      firstName: firstName,
      lastName: lastName,
      email: user?.email,
      phone: formatPhoneNumberWithDash(phone),
      shipIndicator: shippingAddress === billingAddress ? 'billing_address' : 'another_address',
      deliveryTimeframe: 'two_day',
      firstUseDate: "",
      matchBillingAddress: shippingAddress === billingAddress,
    }
  : (deliveryMode === 'domicile'
      ? {
          firstName,
          lastName,
          addressLine1: shippingAddress,
          city: shippingCity,
          postalCode: shippingPostalCode,
          country: shippingCountry.toUpperCase(),
          email: user?.email,
          phone: formatPhoneNumberWithDash(phone),
          shipIndicator: shippingAddress === billingAddress ? 'billing_address' : 'another_address',
          deliveryTimeframe: 'two_day',    
          firstUseDate: "",  
          matchBillingAddress: true,
        }
      : {
          firstName,
          lastName,
          addressLine1: `${selectedLocation.nom} - ${selectedLocation.adresse}`,
          postalCode: selectedLocation.postalCode,
          city: selectedLocation.ville,
          country: selectedLocation.pays,
          email: user?.email,
          phone: formatPhoneNumberWithDash(phone),
          shipIndicator: 'pick-up',
          deliveryTimeframe: 'two_day',
          firstUseDate: "",
          matchBillingAddress: false,
        })
};

console.log("Payload complet :", JSON.stringify(payload, null, 2));

const calcResponse = await fetch('/api/calculate_order.php', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload),
});

const calcData = await calcResponse.json();

if (!calcData.success) {
  alert("Erreur calcul commande");
  return;
}

console.log("Montants sécurisés :", calcData);
setServerTotals(calcData);


if (!user?.email) {
  console.warn("Attention : user.email vide !");
}

console.log("Montant total envoyé :", montantFinal);

    try {
      console.log("Payload envoyé à /api/paiement.php :", JSON.stringify(payload, null, 2));
      const response = await fetch('/api/paiement.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Erreur serveur :", errorText);
        alert("Une erreur est survenue lors de la préparation du paiement.");
        return;
      }

      const html = await response.text();
      console.log("Réponse de /api/paiement.php :", html);
      document.open();
      document.write(html);
      document.close();

    } catch (err) {
      console.error("Erreur fetch :", err);
      alert("Erreur lors de la communication avec le serveur.");
    }
  };

  return (
    <form className="livraison-infos" onSubmit={handleSubmit}>
      <div className="checkout-wrapper" style={{ display: 'flex', gap: '40px' }}>
        <div style={{ flex: 2 }}>
          <div className="contact-form">
            {/* INFOS PERSO */}
            <h3>1. Informations personnelles</h3>
            <input className="input-design" type="text" placeholder="Prénom" value={firstName} onChange={e => setFirstName(e.target.value)} required />
            <input className="input-design" type="text" placeholder="Nom" value={lastName} onChange={e => setLastName(e.target.value)} required />
            <input className="input-design" type="email" value={user?.email || ''} readOnly />
            <input className="input-design" type="tel" placeholder="Téléphone" value={phone} onChange={e => setPhone(e.target.value)} onBlur={(e) => setPhone(formatPhoneNumberWithDash(e.target.value))}/>
          </div>
          {/* INFO SOCIETE */}
          <div className="company-form">
            <h3>Informations société (facultatif)</h3>
            <input className="input-design" type="text" placeholder="Nom de la société" value={companyName} onChange={e => setCompanyName(e.target.value)}/>
            <input className="input-design" type="text" placeholder="Numéro de TVA intracommunautaire" value={vatNumber} onChange={e => setVatNumber(e.target.value)}/>
            <input className="input-design" type="text" placeholder="SIRET" value={siret} onChange={e => setSiret(e.target.value)}/>
          </div>

          <div className="livraison-form">
            {/* Livraison */}
            <h3 style={{ color: isContactComplete ? '#000' : 'gray' }}>2. Adresse de livraison</h3>
            {isContactComplete ? (
              <>
                <div className="mode-livraison">
                  <button
                    type="button"
                    className={`livraison-btn ${deliveryMode === 'domicile' ? 'selected' : ''}`}
                    onClick={() => setDeliveryMode('domicile')}
                  >
                    Point relais
                  </button>
                  <button
                    type="button"
                    className={`livraison-btn ${deliveryMode === 'relais' ? 'selected' : ''}`}
                    onClick={() => setDeliveryMode('relais')}
                  >
                    Click & Collect
                  </button>
                </div>
            
                {deliveryMode === 'domicile' ? (
                  <>
                  <p style={{ fontSize: '16px', marginBottom: '10px', marginTop: '10px',color: '#555' }}>
                    Nous trouvons automatiquement le point relais le plus proche de votre adresse.
                  </p>
                  {/* Sélecteur d’adresses existantes */}
                    {savedAddresses.length > 0 ? (
                      <select
                        className="input-design"
                        value={selectedAddress}
                        onChange={(e) => handleSelectAddress(e.target.value)}
                      >
                        <option value="">-- Sélectionner une adresse enregistrée --</option>
                        {savedAddresses.map(addr => (
                          <option key={addr.id} value={addr.id}>
                            {addr.shippingAddress.addressLine1}, {addr.shippingAddress.city} ({addr.shippingAddress.postalCode})
                          </option>
                        ))}
                      </select>
                    ) : (
                      <p style={{ fontStyle: 'italic', color: 'gray' }}>
                        Aucune adresse enregistrée pour le moment
                      </p>
                    )}
                    <input className="input-design" type="text" placeholder="Adresse de livraison" value={shippingAddress} onChange={e => setShippingAddress(e.target.value)} required />
                    <input className="input-design" type="text" placeholder="Code postal" value={shippingPostalCode} onChange={e => setShippingPostalCode(e.target.value)} required />
                    <input className="input-design" type="text" placeholder="Ville" value={shippingCity} onChange={e => setShippingCity(e.target.value)} required />
                    <select className="input-design" value={shippingCountry} onChange={e => setShippingCountry(e.target.value)} required>
                      <option value="">Sélectionnez un pays</option>
                      <option value="FR">France</option>
                    </select>
                  </>
                ) : (
                  <>
                    <select
                      className="input-design"
                      value={selectedAddress}
                      onChange={(e) => setSelectedAddress(e.target.value)}
                      required
                    >
                      <option value="">-- Choisir un point de retrait --</option>
                      {CLICK_COLLECT_LOCATIONS.map((location) => (
                        <option key={location.id} value={location.id}>
                          {location.nom} - {location.adresse}, {location.postalCode} {location.ville}
                        </option>
                      ))}
                    </select>
                  </>
                )}
              </>
            ) : (
              <p style={{ fontStyle: 'italic', color: 'gray', marginTop: '10px' }}>
                Veuillez d'abord remplir vos informations personnelles pour choisir un mode de livraison.
              </p>
            )}
          </div>

          {isContactComplete && deliveryMode && (
            <div className="facturation-form">
              {/* Facturation */}
              <h3 style={{ color: isShippingComplete ? '#000' : 'gray' }}>3. Adresse de facturation</h3>
              {isShippingComplete ? (
                <>
                  <input className="input-design" type="text" placeholder="Adresse" value={billingAddress} onChange={e => setBillingAddress(e.target.value)} required />
                  <input className="input-design" type="text" placeholder="Code postal" value={billingPostalCode} onChange={e => setBillingPostalCode(e.target.value)} required />
                  <input className="input-design" type="text" placeholder="Ville" value={billingCity} onChange={e => setBillingCity(e.target.value)} required />
                  <select className="input-design" value={billingCountry} onChange={e => setBillingCountry(e.target.value)} required>
                    <option value="">Sélectionnez un pays</option>
                    <option value="FR">France</option>
                  </select>
                </>
              ) : (
                <p style={{ fontStyle: 'italic', color: 'gray', marginTop: '10px' }}>
                  Veuillez d'abord saisir votre adresse de livraison pour choisir l'adresse de facturation.
                </p>
              )}
            </div>
          )}

          <button type="submit" className="valider-infos" disabled={!isContactComplete || !isShippingComplete || !isBillingComplete}>Valider les informations</button>
        </div>

        {/* Recap*/}
        <div className="recap-articles">
          <h3>Récapitulatif</h3>
          {serverTotals && (
            <>
              <p>🛒 Articles : {cartItems.reduce((acc, item) => acc + item.quantity, 0)}</p>
              <p>💶 Total produits : {serverTotals.totalProduits.toFixed(2)} €</p>
              <p>💳 Remise : - {serverTotals.remise.toFixed(2)} €</p>
              <p>🚚 Livraison : {serverTotals.deliveryCost.toFixed(2)} €</p>
              <hr />
              <p><strong>À payer : {serverTotals.totalFinal.toFixed(2)} €</strong></p>
            </>
          )}
        </div>
      </div>
    </form>
    
  );
}

export default Checkout;